// const BASE_URL = "http://localhost:5000";
const BASE_URL = "https://backendsera.onrender.com";
export default BASE_URL;    